import creditBg from '../../../../../assets/images/creditBg.png';
import debitBg from '../../../../../assets/images/debit-card-img.png';
// import debitBg from '../../../../../assets/images/debitBg.png';
import Button from '../../../../common/Button/Button';
import './CommonCardStbl.scss';

const CommonCardStbl = ({
    className, cardNumber, cardName, cardDate, cardCvc = '***',
    onClick, cardType, cardstatus,
    isLoading = false,
}) => {
    if (isLoading) {
        return
        <>
            <div className={`skeleton ${className || ''}`}>

                {/* Card BG Skeleton */}
                <div className="skeleton_imgSec">
                    <div className="skeleton-card-bg shimmer"></div>
                </div>

                {/* Text Skeleton */}
                <div className="skeleton_textSec">
                    <div className="skeleton-text skeleton-card-number shimmer"></div>

                    <div className="infotext">
                        <div className="cardInfouser">
                            <div className="infouser">
                                <div className="skeleton-text skeleton-label shimmer"></div>
                                <div className="skeleton-text skeleton-value shimmer"></div>
                            </div>

                            <div className="infouser">
                                <div className="skeleton-text skeleton-label shimmer"></div>
                                <div className="skeleton-text skeleton-value shimmer"></div>
                            </div>
                        </div>

                        <div className="skeleton-btn shimmer"></div>
                    </div>
                </div>
            </div>
        </>
            ;
    }
    return (
        <>
            <div className={`commonCard ${className || ''}`}>
                <div className='commonCard_imgSec'>
                    <img
                        src={cardType === "DEBIT" ? debitBg : creditBg}
                        alt={cardType === "DEBIT" ? "Debit Card" : "Credit Card"}
                    />
                </div>
                <div className='commonCard_textSec'>
                    <div className='commonCard_textSec_topDetails'>
                        {/* <h6>{cardstatus === "PHYSICAL" ? "Physical" : "Virtual"}</h6> */}
                    </div>
                    <div className='commonCard_textSec_bottomDetails'>

                        <h2 className='smallText'>{cardNumber}</h2>
                        <div className='infotext'>
                            <div className='cardInfouser'>
                                <div className='infouser'>
                                    <label>Card holder name</label>
                                    <p>{cardName}</p>
                                </div>
                                <div className='infouser'>
                                    <label>Expiry date</label>
                                    <p>{cardDate}</p>
                                </div>
                                <div className='infouser'>
                                    <label>CVV</label>
                                    <p>{cardCvc}</p>
                                </div>
                            </div>
                            {onClick &&
                                <Button
                                    className='btn_size'
                                    variant='xtra_small'
                                    onClick={onClick}
                                >
                                    View Card
                                </Button>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default CommonCardStbl